import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as CourierModels from '../../models/couriers/courier';
import { EnvironmentService } from '../environment.service';
import * as Models from '../../models/commonModels';
import * as DictionaryModels from '../../models/dictionary/dictionary';
import { CustomerDictionarySearchModel } from '../../models/customer/customerSearch';

@Injectable({
  providedIn: 'root'
})
export class DictionaryService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getAttachmentType() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/attachment-types`, options);
  }

  public getAfterSalesPeriod() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/after-sales-period`, options);
  }

  public getAdministratorRoles() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/administrator-roles`, options);
  }

  public getCustomers(search: CustomerDictionarySearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.post<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/customers`, search, options);
  }

  public getCustomerRoles() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/customer-roles`, options);
  }

  public getInvoiceTypes() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/invoice-type`, options);
  }

  public getInvoiceStatuses() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/invoice-statuses`, options);
  }

  public getExternalCustomers() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/external-customers`, options);
  }

  public getAddressesDictionary() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.ResponseList<DictionaryModels.AddressesDictionaryModel>>(`${this.environmentService.getApiURL()}/dictionary/addresses-dictionary`, options);
  }

  public getWorkers() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/workers`, options);
  }

  public getCustomerInvoiceSeparateByType() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/customer-invoice-separate-by`, options);
  }

  public getCourierParcelWeight() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/courier-parcel-weights`, options);
  }

  public getCourierParcelValues() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/courier-parcel-values`, options);
  }

  public getCourierGarageOrderDelayDays() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/courier-garage-order-delay-days`, options);
  }

  public getPaymentTypes() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/payment-types`, options);
  }

  public getGarages() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/garages`, options);
  }

  public getCars(RegistrationNumber: string) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/cars/${RegistrationNumber}`, options);
  }

  public getCarBrands() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/car-brands`, options);
  }

  public getCarModels(CarBrandId: number) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/car-models/${CarBrandId}`, options);
  }

  public getCarTypes(CarModelId: number) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/car-types/${CarModelId}`, options);
  }

  public getCostEstimationStatus() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/cost-estimation-status`, options);
  }

  public getGaragePlaceType() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/garage-place-type`, options);
  }

  public getAPIRights() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/api-rights`, options);
  }

  public getAPIServices() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/api-services`, options);
  }

  public getGarageInvoiceStatuses() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/garage-invoice-statuses`, options);
  }

  public GetMessageTypes() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/message-types`, options);
  }

  public GetEmailTypes() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/email-types`, options);
  }

  public GetKsefInvoiceCostStatuses() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/ksef-invoice-cost-statuses`, options);
  }

  public GetKSeFInvoiceTypes() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/ksef-invoice-types`, options);
  }

  public GetKSeFVatRates() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/ksef-vat-rates`, options);
  }

  public GetServiceCostTypes() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/service-cost-types`, options);
  }

  public GetKsefInvoiceSaleStatuses() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(`${this.environmentService.getApiURL()}/dictionary/ksef-invoice-sale-statuses`, options);
  }

  public GetInvoiceKSeFStatuses() {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.get<Models.Response<Models.DictionaryModel[]>>(
      `${this.environmentService.getApiURL()}/dictionary/get-invoice-ksef-statuses`,
      options
    );
  }
}
